<template>
  <DefaultLayout>
    <div class="home-page">
      <h1>Bienvenido a Nexo</h1>
      <p>Plataforma de Agentes de IA con Monetización por Tokens</p>

      <div class="quick-actions">
        <Card class="action-card">
          <template #title>Agentes Disponibles</template>
          <template #content>
            <p>Explora nuestros agentes de IA para diferentes tareas.</p>
            <Button
              label="Ver Agentes"
              icon="pi pi-android"
              class="p-button-block"
              @click="goToAgents"
            />
          </template>
        </Card>

        <Card class="action-card">
          <template #title>Dashboard</template>
          <template #content>
            <p>Monitorea tu uso de tokens y límites.</p>
            <Button
              label="Ir al Dashboard"
              icon="pi pi-chart-bar"
              class="p-button-block"
              @click="goToDashboard"
            />
          </template>
        </Card>

        <Card class="action-card" v-if="authStore.isAdmin">
          <template #title>Administración</template>
          <template #content>
            <p>Gestiona tenants, planes y credenciales.</p>
            <Button
              label="Ir a Tenants"
              icon="pi pi-users"
              class="p-button-block"
              @click="goToTenants"
            />
          </template>
        </Card>
      </div>
    </div>
  </DefaultLayout>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useAuthStore } from '../stores/auth';
import DefaultLayout from '../components/layout/DefaultLayout.vue';
import Card from 'primevue/card';
import Button from 'primevue/button';

const router = useRouter();
const authStore = useAuthStore();

const goToAgents = () => {
  router.push('/agents');
};

const goToDashboard = () => {
  router.push('/dashboard');
};

const goToTenants = () => {
  router.push('/tenants');
};
</script>

<style scoped>
.home-page h1 {
  margin-bottom: 0.5rem;
  color: #1e293b;
}

.home-page p {
  margin-bottom: 2rem;
  color: #6b7280;
}

.quick-actions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  margin-top: 2rem;
}

.action-card {
  text-align: center;
}
</style>